import {Component, Input, OnDestroy, OnInit} from '@angular/core';
import {Tile} from "../../Tile";
import {DigitaloutDescriptionDataservice} from "../../digitalout/digitalout-description-dataservice";
import {DigitaloutStatusDataservice} from "../../digitalout/digitalout-status-dataservice";
import {cIOMAPPEDFREQUENCY, FrequencyStatus} from "../frequencyStatus";
import {FrequencyStatusDataservice} from "../frequency-status-dataservice";
import {interval, Subscription} from "rxjs";
import {FrequencydetailsComponent} from "../frequencydetails/frequencydetails.component";
import {environment} from "../../../environments/environment";

@Component({
  selector: 'app-frequencylist',
  templateUrl: './frequencylist.component.html',
  styleUrls: ['./frequencylist.component.css']
})
export class FrequencylistComponent implements OnInit, OnDestroy {
  fqStatus: FrequencyStatus | undefined;
  private updateSubscription: Subscription | undefined;
  errorMessage: string = "";
  componentList = Array<FrequencydetailsComponent>();
  public loaderStatus: number = 0;

  counter(i: number) {
    return new Array(i);
  }

  constructor(private frequencyStatusDataservice: FrequencyStatusDataservice)                {  }


  ReSubscribe(): void{
    this.updateSubscription = interval(environment.interval).subscribe(
      () => {
        this.UpdateData();
      });
  }

  UpdateData(): void {
    this.updateSubscription?.unsubscribe();
    this.loaderStatus = -1;
    this.frequencyStatusDataservice.GetData().subscribe(
      {
        next: fqStatus => {
          this.loaderStatus = 1;
          this.fqStatus = fqStatus;
          this.componentList.forEach((detail => {
            detail.UpdateFqState(this.GetStatus(detail.refNumber));
          }));
          this.ReSubscribe();
        }, error: err => this.errorMessage = err
      });
  }


  ngOnInit(): void {
    this.UpdateData();
  }

  ngOnDestroy(): void {
    this.updateSubscription?.unsubscribe();
  }


  Add(frequencydetailsComponent: FrequencydetailsComponent): void
  {
    this.componentList.push(frequencydetailsComponent);
  }


  GetStatus(refNumber: number): cIOMAPPEDFREQUENCY {
    if( ( this.fqStatus) && (this.fqStatus.cIO_MAPPED_FREQUENCY[refNumber]))
      return this.fqStatus.cIO_MAPPED_FREQUENCY[refNumber];
    return new cIOMAPPEDFREQUENCY();
  }



}
